// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://breqydpjtdocbmqcrqhi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJyZXF5ZHBqdGRvY2JtcWNycWhpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDU1MjYwODMsImV4cCI6MjA2MTEwMjA4M30.2gKebIaPeRrHsGb2eqUGEktqVLTMG1zCirdHmKJrfKA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);